import React from "react";
import { Container, Row, Col } from "shards-react";
import AdminPanelIndex from "../../components/adminpanel";

import PageTitle from "../../components/common/PageTitle";
import FooterComponent from "../../components/Footer/FooterComponent";
import FrontendHomeComponent from "../../components/frontend";
import ParticipantDetailsIndex from "../../components/frontend/ParticipantDetailsComponent";
import ParticipantIndex from "../../components/frontend/participantIndex";
import ReceptIndex from "../../components/frontend/receptComponent";
import ReceptDetailsIndex from "../../components/frontend/receptsDetailsComponent";
import HeaderComponent from "../../components/Header/headerComponent";
import ProductsIndex from "../../components/products";



const ParticipantDetailsView = ({match,location}) => (
    <div>
    <HeaderComponent/>
    <ParticipantDetailsIndex id={location.search}/>
    <FooterComponent/>
    
    </div>
);

export default ParticipantDetailsView;
